const loadImage = source => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = () => reject(new Error('Imagine invalidă.'));
  image.src = source;
});

async function hasTransparency(source) {
  const image = await loadImage(source);
  const size = 64;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(image, 0, 0, size, size);
  const data = ctx.getImageData(0, 0, size, size).data;
  for (let i = 3; i < data.length; i += 4) {
    if (data[i] < 250) return true;
  }
  return false;
}

export async function allTransparent(sponsors) {
  if (!sponsors.length) return false;
  try {
    const results = await Promise.all(sponsors.map(item => hasTransparency(item.image)));
    return results.every(Boolean);
  } catch {
    return false;
  }
}